import { Menu, MenuItem, Stack } from "@mui/material";
import { useRef, useState } from "react";
import { Chip } from "~/common/mui/Chip/Chip";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CheckIcon from "@mui/icons-material/Check";

export interface SelectChipOption {
  label: string;
  value: string;
}

export interface SelectChipProps {
  className?: string;
  value: string;
  values: SelectChipOption[];
  onChange: (event: React.MouseEvent<HTMLLIElement>, value: string) => void;
  disabled?: boolean;
  showSelectedIcon?: boolean;
}

export const SelectChip = ({
  className,
  value,
  values,
  onChange,
  showSelectedIcon = false,
  disabled = false,
}: SelectChipProps) => {
  const [open, setOpen] = useState(false);
  const chipRef = useRef<HTMLDivElement | null>(null);

  // Find the current selected option
  const selectedOption = values.find((option) => option.value === value);
  const displayLabel = selectedOption?.label || value;

  const handleItemClick = (event: React.MouseEvent<HTMLLIElement>, selectedValue: string) => {
    onChange(event, selectedValue);
    setOpen(false);
  };

  const toggleMenu = () => {
    if (!disabled) {
      setOpen((prev) => !prev);
    }
  };

  return (
    <>
      <Chip
        className={className}
        variant="assist"
        disabled={disabled}
        label={displayLabel}
        deleteIcon={<ArrowDropDownIcon sx={{ transform: open ? "rotate(180deg)" : "" }} />}
        onDelete={toggleMenu}
        onClick={toggleMenu}
        ref={chipRef}
      />
      <Menu
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={chipRef.current}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {values.map(({ label, value: optionValue }) => {
          const isSelected = optionValue === value;
          return (
            <MenuItem key={optionValue} onClick={(event) => handleItemClick(event, optionValue)} selected={isSelected}>
              <Stack direction={"row"} gap={1.5} justifyContent={"space-between"}>
                {label}
                {showSelectedIcon && isSelected && <CheckIcon fontSize="medium" color="onSecondaryContainer" />}
              </Stack>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};
